export default {
  IAO_ELIGIBLE_OFFERS: 'iao_eligible_offers',
  IAO_OFFERS: 'iao_offers'
};